// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"1a912f59","146":"4f4fee60","787":"3c912811","981":"8e643197"}[chunkId] + ".chunk.js";
};